<template>
  <div v-if="isVisible">
    <div class="modal show custom-confirm" tabindex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              {{ confirmTitle }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col">
                <p v-html="confirmQuestion"></p>
              </div>
            </div>
            <div v-if="isChoice" class="row mb-2">
              <div class="form-group col d-flex align-items-center">
                <span class="me-2"><span class="custom-astrisk">*</span>{{ choiceLabel }}</span>
                <select class="form-control" v-model="choice">
                  <option v-for="choice in choices" :key="choice.id" :value="choice.id">{{ choice.name }}</option>
                </select>
              </div>
            </div>
            <div v-if="isText" class="row">
              <div class="form-group col">
                <textarea class="form-control" rows="4" v-model="confirmText"></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="close()">
              {{ cancelAction }}
            </button>
            <button v-if="isConfirmAction" type="submit" class="btn btn-primary" :disabled="isReady" @click="proceed()">
              {{ confirmAction }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show custom-confirm-back"></div>
  </div>
</template>
<script>
export default {
  name: 'ZDialogConfirm',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    confirmTitle: String,
    confirmAction: {
      type: String,
      default: ''
    },
    confirmQuestion: String,
    cancelAction: {
      type: String,
      default: 'Cancel'
    },
    isChoice: {
      type: Boolean,
      default: false
    },
    choiceLabel: {
      type: String,
      default: 'Select'
    },
    choices: {
      type: Array,
      default: () => []
    },
    isText: {
      type: Boolean,
      default: false
    },
    defaultText: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      choice: null,
      confirmText: ''
    }
  },
  watch: {
    defaultText: {
      immediate: true,
      handler(value) {
        this.confirmText = value
      }
    }
  },
  emits: ['proceed', 'closing'],
  computed: {
    isVisible: {
      get() {
        return this.modelValue
      }
    },
    isConfirmAction() {
      let _is = true
      if (this.confirmAction === '') {
        _is = false
      }
      return _is
    },
    isReady() {
      let _is = false
      if (this.isChoice && this.choice === null) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    proceed() {
      this.$emit('proceed', {
        choice: this.choice,
        confirmText: this.confirmText
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-confirm {
  display: block;
  z-index: 1085;
}
.custom-confirm-back {
  z-index: 1080;
}
.custom-astrisk {
  position: relative;
  color: red;
  top: -5px;
}
</style>
